export type PayoutRateUi = "100" | "150" | "200";

export function tryParsePayoutRate(
  rawRate: string | number | null | undefined
): PayoutRateUi | null {
  const normalized = String(rawRate ?? "").trim().toLowerCase();
  if (!normalized) return null;

  if (normalized === "paid100" || normalized === "100") return "100";
  if (normalized === "paid150" || normalized === "150") return "150";
  if (normalized === "paid200" || normalized === "200") return "200";

  if (normalized.includes("100")) return "100";
  if (normalized.includes("150")) return "150";
  if (normalized.includes("200")) return "200";

  const asNumber = Number(rawRate);
  if (asNumber === 100) return "100";
  if (asNumber === 150) return "150";
  if (asNumber === 200) return "200";

  return null;
}

export function normalizePayoutRate(
  rawRate: string | number | null | undefined
): PayoutRateUi {
  return tryParsePayoutRate(rawRate) ?? "100";
}
